import { compose as e } from "../../tailwind-buddy-interface.js";
import { labelStyles as o } from "../../mixins/typography.js";
const s = e({
  slots: {
    root: `
      hz-toggle
      
      relative 
      inline-flex
      items-start
      gap-100
      max-w-full
    `,
    content: `
      grow
      flex
      items-start
      gap-025
    `,
    labelIcon: "shrink-0",
    container: `
      grow
      grid
      grid-cols-1 
      gap-050
      pt-050
    `,
    label: `
      ${o.md}
      select-none
      break-words
      
      
      before:absolute 
      before:inset-x-0
      before:inset-y-0
      before:cursor-pointer
    `,
    supportText: `
      z-[1] 
      cursor-auto 
    `
  },
  variants: {
    /** Sets the label's position relative to the checkbox icon. */
    labelPosition: {
      end: {},
      start: {
        root: "flex-row-reverse"
      }
    }
  },
  compoundVariants: [
    // isDisabled="false"
    {
      conditions: { isDisabled: !1 },
      class: {
        root: "cursor-pointer",
        label: "before:cursor-pointer"
      }
    },
    // isDisabled="true"
    {
      conditions: { isDisabled: !0 },
      class: {
        root: "cursor-not-allowed",
        labelIcon: "*:text-color-scheme-interactive-disabled-400",
        label: "before:cursor-not-allowed text-color-scheme-interactive-disabled-500"
      }
    }
  ],
  responsiveVariants: [],
  defaultVariants: {
    labelPosition: "end"
  }
})();
export {
  s as formToggleVariants
};
